function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .checkbox_svg__checkbox_svg__cls-1{fill:none;stroke:#717375;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}\n    "));

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\n    requirement\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("polyline", {
  className: "checkbox_svg__checkbox_svg__cls-1",
  points: "4.51 10.05 8.55 14.09 21.89 0.75"
}), /*#__PURE__*/React.createElement("path", {
  className: "checkbox_svg__checkbox_svg__cls-1",
  d: "M16.93,8.6v7.87a2.4,2.4,0,0,1-2.4,2.4H3.15a2.39,2.39,0,0,1-2.4-2.4V5.09A2.39,2.39,0,0,1,3.15,2.7H14.53a2.39,2.39,0,0,1,1.7.7"
})));

function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.64,
    height: 19.62,
    viewBox: "0 0 22.64 19.62"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCheckbox;